import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, Lock, ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

const AdminLogin = () => {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user.email) navigate("/admin/dashboard");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Accesso effettuato");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "bg-stone-900/60 border-stone-800 text-white placeholder:text-stone-500 focus:ring-2 focus:ring-[#d4af37] focus:ring-offset-2 focus:ring-offset-[#0c0c0c] rounded-sm h-12";

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-[#0c0c0c] flex items-center justify-center px-6 grain-overlay">
      <div className="relative z-10 w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 text-stone-500 hover:text-gold transition-colors text-sm mb-8">
          <ArrowLeft size={16} /> Torna al sito
        </Link>
        <div className="border border-stone-800 bg-[#111] p-9">
          <div className="flex items-center gap-3 mb-8">
            <span className="w-11 h-11 bg-gold/10 border border-gold/40 flex items-center justify-center text-gold"><Lock size={20} /></span>
            <div>
              <h1 className="font-serif text-2xl text-white">Area Riservata</h1>
              <p className="text-xs uppercase tracking-widest text-stone-500 mt-1">Salvatore Castelli</p>
            </div>
          </div>

          <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
            <div className="space-y-2">
              <Label className="text-xs uppercase tracking-widest text-stone-400">Email</Label>
              <Input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="email@esempio.it" className={inputCls} />
            </div>
            <div className="space-y-2">
              <Label className="text-xs uppercase tracking-widest text-stone-400">Password</Label>
              <Input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className={inputCls} />
            </div>
            <button
              type="submit"
              data-testid="admin-login-submit"
              disabled={loading}
              className="w-full bg-gold text-[#0c0c0c] uppercase tracking-[0.15em] text-sm font-medium py-4 hover:bg-[#b5952f] transition-colors duration-300 disabled:opacity-60 flex items-center justify-center gap-2"
            >
              {loading && <Loader2 size={18} className="animate-spin" />}
              Accedi
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
